import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../Core/Store";
import { isEqual, update } from "lodash";
import { push } from "react-router-redux";
import cloneDeep from 'lodash/cloneDeep';
import { createSelector } from '@reduxjs/toolkit';

export interface ISearchSliceState {
  searchAll: string;
}
const defaultState: any = {
    searchAll: "",
    country: "",
    customerID: "",
    projectNr: "",
    machineSerial: "",
    dataSource: "MPE , D365"
};
const getInitialFilters = () => {
    return defaultState;
};
const initialState: any = getInitialFilters();

export const updateSearch2 = createAsyncThunk(
  "search/updateSearch",
  async (search: ISearchSliceState, thunkAPI: any) => {
    const path = thunkAPI.getState().router.location.pathname;

    if (!isEqual(thunkAPI.getState().search, search)) {
      thunkAPI.dispatch(push(path, search));
    }
    return search;
  }
);

const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    updateSearch: (state, action: PayloadAction<any>) => {
      if (action.payload === null) {
        return initialState;
      }
      return action.payload;
    },
  },
  //,
  //extraReducers(builder) {
  //    builder.addCase(updateSearch.fulfilled, (state, action) => {
  //        return action.payload;
  //    });
  //},
});

export const { updateSearch } = searchSlice.actions;

export const getSearchSelector = (state: RootState) => state.search;

export default searchSlice.reducer;

function sortObjectArrays(obj) {
    const sortedObj = cloneDeep(obj); // Deep copy to avoid mutating the original object
    Object.keys(sortedObj).forEach(key => {
        if (Array.isArray(sortedObj[key])) {
            sortedObj[key].sort();
        }
    });
    return sortedObj;
}

export const isSearchStateDifferentFromDefault = createSelector(
    [getSearchSelector],
    (currentAlarmState) => {
        return !isEqual(sortObjectArrays(currentAlarmState), sortObjectArrays(defaultState));
    }
);
